import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "fixed-nav__actions" }
const _hoisted_3 = { class: "phone mr-5" }
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_PropertyLeasePeriods = _resolveComponent("PropertyLeasePeriods")!
  const _component_property_friends = _resolveComponent("property-friends")!
  const _component_property_about = _resolveComponent("property-about")!
  const _component_property_gallery = _resolveComponent("property-gallery")!
  const _component_property_features = _resolveComponent("property-features")!
  const _component_property_additional_resources = _resolveComponent("property-additional-resources")!
  const _component_property_location = _resolveComponent("property-location")!
  const _component_testimonials_carousel = _resolveComponent("testimonials-carousel")!
  const _component_how_it_works = _resolveComponent("how-it-works")!
  const _component_contact_form = _resolveComponent("contact-form")!
  const _component_page_layout = _resolveComponent("page-layout")!

  return (_openBlock(), _createBlock(_component_page_layout, {
    class: "property-page",
    loaded: !!_ctx.property,
    title: _ctx.property ? _ctx.property.name : '',
    text: _ctx.fullAddress,
    media: _ctx.propertyMedia,
    socials: _ctx.socials,
    "place-text-bottom": ""
  }, {
    default: _withCtx(() => [
      (_ctx.property)
        ? (_openBlock(), _createBlock(_component_v_layout, {
            key: 0,
            "align-center": "",
            class: "fixed-nav",
            style: {"position":"fixed","background-color":"white","z-index":"1000"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_container, {
                "align-center": "",
                class: "d-flex"
              }, {
                default: _withCtx(() => [
                  (_ctx.property)
                    ? (_openBlock(), _createElementBlock("h3", _hoisted_1, _toDisplayString(_ctx.property.name), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("a", {
                        class: "text-secondary",
                        href: 'tel:' + _ctx.property.phone_number
                      }, _toDisplayString(_ctx.property.phone_number), 9, _hoisted_4)
                    ]),
                    _createVNode(_component_v_btn, {
                      color: "primary",
                      size: "large",
                      onClick: _ctx.checkAvailability
                    }, {
                      default: _withCtx(() => _cache[0] || (_cache[0] = [
                        _createTextVNode(" Check Availability ")
                      ])),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.getBlockVisibility('lease-periods'))
        ? (_openBlock(), _createBlock(_component_PropertyLeasePeriods, {
            key: 1,
            property: _ctx.property,
            description: _ctx.getBlockDescription('lease-periods')
          }, null, 8, ["property", "description"]))
        : _createCommentVNode("", true),
      (_ctx.getBlockVisibility('friends'))
        ? (_openBlock(), _createBlock(_component_property_friends, {
            key: 2,
            "property-id": `${_ctx.property.id}`,
            description: _ctx.getBlockDescription('friends')
          }, null, 8, ["property-id", "description"]))
        : _createCommentVNode("", true),
      (_ctx.getBlockVisibility('about'))
        ? (_openBlock(), _createBlock(_component_property_about, {
            key: 3,
            text: _ctx.property.general_info
          }, null, 8, ["text"]))
        : _createCommentVNode("", true),
      (_ctx.getBlockVisibility('gallery') && _ctx.property.property_images.length)
        ? (_openBlock(), _createBlock(_component_property_gallery, {
            key: 4,
            images: _ctx.property.property_images,
            description: _ctx.getBlockDescription('gallery')
          }, null, 8, ["images", "description"]))
        : _createCommentVNode("", true),
      (_ctx.getBlockVisibility('features') && _ctx.property.amenities.length)
        ? (_openBlock(), _createBlock(_component_property_features, {
            key: 5,
            features: _ctx.property.amenities,
            description: _ctx.getBlockDescription('features')
          }, null, 8, ["features", "description"]))
        : _createCommentVNode("", true),
      (_ctx.getBlockVisibility('additional-resources') && _ctx.property.additional_resources.length)
        ? (_openBlock(), _createBlock(_component_property_additional_resources, {
            key: 6,
            resources: _ctx.property.additional_resources,
            description: _ctx.getBlockDescription('additional-resources')
          }, null, 8, ["resources", "description"]))
        : _createCommentVNode("", true),
      (_ctx.getBlockVisibility('location'))
        ? (_openBlock(), _createBlock(_component_property_location, {
            key: 7,
            address: _ctx.fullAddress
          }, null, 8, ["address"]))
        : _createCommentVNode("", true),
      (_ctx.getBlockVisibility('what-people-say'))
        ? (_openBlock(), _createBlock(_component_testimonials_carousel, {
            key: 8,
            "property-id": `${_ctx.property.id}`
          }, null, 8, ["property-id"]))
        : _createCommentVNode("", true),
      (_ctx.getBlockVisibility('how-it-works'))
        ? (_openBlock(), _createBlock(_component_how_it_works, { key: 9 }))
        : _createCommentVNode("", true),
      (_ctx.getBlockVisibility('contact-form'))
        ? (_openBlock(), _createBlock(_component_contact_form, {
            key: 10,
            "property-id": _ctx.property.id,
            "contact-data": _ctx.property
          }, null, 8, ["property-id", "contact-data"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["loaded", "title", "text", "media", "socials"]))
}